import { APP_ENV } from "../../config/config.js";

// Per-environment visual identity for the navbar env label.
// PRO has no entry, so getEnvStyle returns null and the badge is hidden.
const ENV_STYLES = {
  LOCAL: { bg: "#374151", fg: "#ffffff", label: "LOCAL" },
  DEV: { bg: "#0d9488", fg: "#ffffff", label: "DEV" },
  TST: { bg: "#ea580c", fg: "#ffffff", label: "TST" },
  UAT: { bg: "#7c3aed", fg: "#ffffff", label: "PRE-PRODUCTION" },
};

export function getEnvStyle(env = APP_ENV) {
  return ENV_STYLES[env] || null;
}
